import moment from 'moment';

export function durationToSeconds(duration = '') {
  if (typeof duration === 'string') {
    let d = duration.split(':') || [];

    if (d.length === 1) {
      return d[0];
    } else if (d.length === 2) {
      return +d[0] * 60 + +d[1];
    } else if (d.length === 3) {
      return +d[0] * 60 * 60 + +d[1] * 60 + +d[2];
    } else {
      return duration;
    }
  }
}

export function formatDuration(duration, countUp) {
  if (!duration && duration !== 0) {
    return '';
  }

  try {
    let seconds;
    let ms;

    if (typeof duration === 'number' || duration.indexOf(':') === -1) {
      seconds = duration;
    } else {
      seconds = durationToSeconds(duration);
    }

    if (typeof duration === 'string' && duration.indexOf(':') === -1) {
      ms = moment.duration(duration * 1000).asMilliseconds();
    } else {
      ms = moment.duration(seconds * 1000).asMilliseconds();
    }

    if (seconds >= 3600) {
      return moment.utc(ms).format('h:mm:ss');
    } else if (seconds >= 60 || countUp) {
      if (countUp) {
        return moment.utc(ms).format('mm:ss');
      } else {
        return moment.utc(ms).format('m:ss');
      }
    } else {
      return moment.utc(ms).format('mm:ss');
    }
  } catch (e) {
    console.error(e);
  }
}

export function formatDurationMillis(duration, countUp) {
  if (!duration && duration !== 0) {
    return '';
  }

  try {
    let seconds;
    let ms;

    if (typeof duration === 'number' || duration.indexOf(':') === -1) {
      seconds = duration;
    } else {
      seconds = durationToSeconds(duration);
    }

    if (typeof duration === 'string' && duration.indexOf(':') === -1) {
      ms = moment.duration(duration * 1000).asMilliseconds();
    } else {
      ms = moment.duration(seconds * 1000).asMilliseconds();
    }

    if (seconds >= 3600) {
      return moment.utc(ms).format('h:mm:ss:SSS');
    } else if (seconds >= 60 || countUp) {
      if (countUp) {
        return moment.utc(ms).format('mm:ss:SSS');
      } else {
        return moment.utc(ms).format('m:ss:SSS');
      }
    } else {
      return moment.utc(ms).format('mm:ss:SSS');
    }
  } catch (e) {
    console.error(e);
  }
}

export function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

function randomInRange(min, max) {
  return Math.random() < 0.5 ? (1 - Math.random()) * (max - min) + min : Math.random() * (max - min) + min;
}

export function getFakePeaks(min, max, length = 2049) {
  let fakePeaks = [];

  for (let i = 0; i < length; i++) {
    if (i % 13 === 0 && !(min && max)) {
      fakePeaks.push(-0.089);
    } else if (i % 18 === 0 && !(min && max)) {
      fakePeaks.push(0.045);
    } else {
      if (min && max) {
        fakePeaks.push(randomInRange(min, max));
      } else {
        fakePeaks.push(randomInRange(-0.5, 0.6));
      }
    }
  }

  return fakePeaks;
}

export function calculateZoom(formattedDuration) {
  let duration = durationToSeconds(formattedDuration);
  if (duration < 301) {
    return 1;
  } else if (duration < 1801) {
    return 0.5;
  } else {
    return 0.1;
  }
}
